import type { errors as en } from '@/i18n/locales/en/errors';
import type { Translation } from '@/i18n/types';

export const errors: Translation<typeof en> = {
  loading: 'Cargando {{label}}…',
  forbidden: 'No tienes permiso para ver {{label}}.',
  notFound: 'No se pudo encontrar {{label}}.',
  loadingFailed: 'Error al cargar {{label}}: {{message}}',
  submitForbidden: 'No tienes permiso para hacer esto{{suffix}}',
  submitConflict: 'Esto entra en conflicto con el estado actual{{suffix}}',
  submitGeneric: 'Algo salió mal: {{message}}',
};
